import type { ModuleValue } from './types';

/** Route the Bulk Edit page is mounted at (see routes.js). */
export const BULK_EDIT_ROUTE = '/modules-bulk-edit';

/**
 * Select Module dropdown options. Labels resolve through the `bulk-edit` i18n
 * namespace at the call-site (the page maps `labelKey` → `t(labelKey)`), so the
 * list stays single-source here.
 */
export const MODULE_OPTIONS: ReadonlyArray<{ value: ModuleValue; labelKey: string }> = [
  { value: 'measurements', labelKey: 'MEASUREMENTS' },
  { value: 'design-details', labelKey: 'DESIGN_DETAILS' },
];
